import React, { useState, useRef, useEffect } from 'react';
import { APP_ROUTES } from '../../../common/globalConstants';
import SelectedCategory from './SelectedCategory';
import SignOutButton from './signOut';
const navMenues = {
  dashboard: ['dashboard', 'compare'],
  topics: ['topics'],
  sources: ['sources'],
  reports: ['reports'],
  'user-management': [],
};

const Header = ({
  props,
  setCategorySelectionModalActive,
  setActiveTopic,
  setActiveTab,
  setIsChangePassword,
}) => {
  const [showSettings, toggleSettings] = useState(false);
  const [toggle, setToggle] = useState('dashboard');
  const [activeRoute, setRoute] = useState('dashboard');
  const handleDashboardToggle = data => {
    setToggle(data);
    setActiveTab(data);
  };

  useEffect(() => {
    let _path = getCurrentRoute();
    if (navMenues[_path]) {
      setRoute(_path);
      setToggle(
        navMenues[_path].includes(props.App.activeTab) ? props.App.activeTab : navMenues[_path][0],
      );
    }
  }, [props.location]);

  const getCurrentRoute = () => {
    let _path = props.location.pathname.split('/');
    _path = _path.length > 1 ? _path[_path.length - 1] : APP_ROUTES.DASHBOARD;
    return _path;
  };

  const wrapperRef = useRef(null);
  function useOutsideClick(ref) {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        toggleSettings(false);
      }
    }
    useEffect(() => {
      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    });
  }

  const isShowCategory = () => {
    const route = getCurrentRoute();
    return route !== APP_ROUTES.USER_MANAGEMENT;
  };

  useOutsideClick(wrapperRef);
  return (
    <header>
      <div className="container-fluid">
        <div className={`row content`}>
          {isShowCategory() && (
            <SelectedCategory
              isCategorySelectionModalActive={e => setCategorySelectionModalActive(e)}
              topics={props.App.headerTopicData}
              topicsDropDown={props.App.topicDropdown}
              setSelectedTopicActive={e => setActiveTopic(e)}
            />
          )}
          <div className="dash-div">
            {navMenues[activeRoute].map((navmenu, index) => (
              <div
                className={['dashboard', toggle === navmenu ? 'active' : ''].join(' ')}
                onClick={() => handleDashboardToggle(navmenu)}
                key={index}
              >
                {navmenu}
              </div>
            ))}
          </div>
          <div
            className={`user ${showSettings ? 'active' : ''}`}
            onClick={() => toggleSettings(!showSettings)}
            ref={wrapperRef}
          >
            <i className="la la-user "></i>
            <div className={`user-block ${showSettings ? 'show' : ''}`}>
              <ul>
                <li onClick={() => setIsChangePassword(true)}>Change Password</li>
                <li>Price Plans</li>
                <SignOutButton />
              </ul>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;



// WEBPACK FOOTER //
// ./src/features/shared-components/Header/Header.js